import React, { useEffect, useState } from "react";
import Sidenav from "../Sidenav/Sidenav";
import SideNavLayout from "../Sidenav/SideNavLayout";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { useNavigate } from "react-router-dom";
import blinkscribelogo from "../assets/Ntact.png";
import { editpen } from "./svg";

import axios from "axios";
import { Snackbar, Alert, CircularProgress, Backdrop } from "@mui/material";
import api from "../api/api";
import Toast from "../global/toastmessage";

const Supporthome = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [isEditable, setIsEditable] = useState(false);
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Toast states
  const [open, setOpen] = useState(false);
  const [tMessage, setTMessage] = useState("");
  const [severity, setSeverity] = useState("success");
const handleCloseToast = (event, reason) => {
  if (reason === "clickaway") return; // Prevent closing on outside click
  setOpen(false);
};

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 10 * 1024 * 1024) {
      setTMessage("File size exceeds 10MB limit.");
      setSeverity("error");
      setOpen(true);
      return;
    }
    setFile(selectedFile);
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Invalid email address.";
    }
    if (!message.trim()) newErrors.message = "Message is required.";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    await sendEmail();
  };

  const sendEmail = async () => {
    setLoading(true);
    try {
      const formData = new FormData();

      const currentTime = new Date().toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });

      const htmlContent = `
        <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
          <p>Dear Support Team,</p>
          <p>A user has submitted a message via the <strong>Help & Support</strong> form. Below are the details:</p>
          <hr style="border: none; border-top: 1px solid #ccc;" />
          <h3 style="color: #156CFE; margin-top: 20px;">Message:</h3>
          <div style="background-color: #f4f8ff; padding: 12px; border-left: 4px solid #156CFE; border-radius: 4px;">
            ${message.replace(/\n/g, "<br/>")}
          </div>
          <h4 style="margin-top: 25px; margin-bottom: 5px;">User Details</h4>
          <ul style="list-style-type: none; padding-left: 0;">
            <li><strong>Email:</strong> ${email}</li>
            <li><strong>Username:</strong> ${username || "N/A"}</li>
            <li><strong>Submitted At:</strong> ${currentTime}</li>
          </ul>
          <hr style="border: none; border-top: 1px solid #ccc;" />
          <p style="margin-top: 25px;">Please respond as soon as possible.</p>
          <p>Best regards,<br/>System Notification - Help Desk</p>
        </div>
      `;

      formData.append("to", "admin@brainymed.com");
      formData.append("subject", `New support request from ${username || email}`);
      formData.append("message", htmlContent);
      if (file) {
        formData.append("files", file);
      }

      await axios.post(`https://api.prd.brainymed.com/utility/send-email`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setTMessage("Message sent successfully.");
      setSeverity("success");
      setOpen(true);

      // Clear form
      setMessage("");
      setFile(null);
    } catch (error) {
      console.error("Email send failed:", error);
      setTMessage("Failed to send the message.");
      setSeverity("error");
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  // Fetch user info
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await api.get("/auth/me");
        setEmail(res?.email || "");
        setUsername(res?.firstname +' '+res?.lastname || "user");
      } catch (err) {
        console.log(err);
      }
    };
    fetchUser();
  }, []);

  return (
    <SideNavLayout>
      <div className="flex items-center justify-center ">
       
        <div className="mt-8 bg-white shadow-lg rounded-lg flex w-full max-w-5xl overflow-hidden">
          {/* Left */}
          <div className="w-[60%] p-8 text-start">
            <h3 className="text-lg font-semibold text-[#121212]">Get in Touch</h3>
            <h1 className="text-3xl font-bold mt-1 mb-2 text-[#0D141C]">
              Hello, {username || "there"}, let's chat!
            </h1>
            <p className="text-sm text-[#000] mb-6">
              We've pre-filled your details from your profile. Please confirm or edit them below.
            </p>

            <label className="block text-sm mb-1">Email</label>
            <div className="relative mb-2">
              <input
                type="email"
                value={email}
                readOnly={!isEditable}
                onChange={(e) => setEmail(e.target.value)}
                className={`w-full border-b py-2 px-3 pr-10 ${
                  isEditable ? "ring-1 ring-blue-100 bg-white" : "bg-gray-100"
                }`}
              />
              <span
                className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer"
                onClick={() => setIsEditable(!isEditable)}
              >
                {editpen}
              </span>
            </div>
            {errors.email && <p className="text-red-500 text-sm mb-2">{errors.email}</p>}

            <label className="block text-sm mt-4 mb-1">Message</label>
            <textarea
              rows={5}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full border px-3 py-2 text-sm resize-none"
              placeholder="Let us know how we can help you.."
            />
            {errors.message && <p className="text-red-500 text-sm mb-2">{errors.message}</p>}

            <div className="mt-4 border-2 border-dashed p-4 rounded">
              <p className="text-sm font-semibold mb-2">
                Attach a file <span className="font-normal text-gray-500">(Max 10MB)</span>
              </p>
              <label className="cursor-pointer bg-gray-200 px-4 py-1 rounded text-sm">
                Upload File
                <input type="file" onChange={handleFileChange} className="hidden" />
              </label>
              {file && (
                <div className="mt-2 flex items-center justify-between bg-gray-100 px-2 py-1 rounded">
                  <p className="text-sm truncate">{file.name}</p>
                  <button onClick={() => setFile(null)} className="text-red-600 text-lg font-bold">
                    ×
                  </button>
                </div>
              )}
            </div>

            <button
              onClick={handleSubmit}
              className="mt-4 bg-[#156CFE] hover:bg-blue-700 text-white px-6 py-2 rounded text-sm font-medium"
            >
              Send Message
            </button>
          </div>

          {/* Right */}
          <div className="w-[40%] p-8" style={{ background: "linear-gradient(to bottom, white 0%, white 30%, #A2C6FDCC 100%)" }}>
            <div className="w-full flex justify-center mb-4">
              <img src={blinkscribelogo} alt="blinkScribe Logo" className="w-[100px]" />
            </div>
            <p className="mb-2">You can also reach us at:</p>
            <p className="text-sm text-[#1E2939]">admin@brainymed.com</p>
            <p className="text-sm text-[#1E2939]">(682) 344 0264</p>
            {/* <p className="text-sm mt-4">For more information, visit our FAQ page.</p>
            <a href="#" className="text-blue-600 text-sm">
              Go to FAQ
            </a> */}
          </div>
        </div>

        {/* Toast */}
         <Toast
          open={open}
          onClose={handleCloseToast}
          severity={severity}
          message={tMessage}
        />

        {/* Loading Spinner */}
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
    </SideNavLayout>
  );
};

export default Supporthome;
